<template>
  <div>
    <div class="head">资质字段</div>
    <div class="rowContainer" v-for="item in filedsList" :key="item.title">
      <div class="itemTitle">{{ item.title }}</div>
      <div
        class="filedContainer"
        v-for="(filed, index) in item.list"
        :key="index"
      >
        <div class="fieldName">{{ filed.filedsName }}</div>
        <div class="filedChecks">
          <el-checkbox label="提交使用" v-model="filed.submit"></el-checkbox>
          <el-checkbox label="审核使用" v-model="filed.examine"></el-checkbox>
          <el-checkbox label="必填项" v-model="filed.required"></el-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "QFields",
  props: {
    filedsList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>
<style scoped lang='scss'>
.itemTitle {
  color: red;
  line-height: 30px;
  font-size: 12px;
}
.rowContainer {
  padding-left: 40px;
  padding-top: 10px;
}
.filedContainer {
  padding-left: 20px;
  display: flex;
  font-size: 12px;
  align-items: center;
  height: 30px;
  line-height: 30px;
  .fieldName {
    padding-right: 10px;
    width: 200px;
  }
}
</style>